import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ClientTypeDto } from 'src/app/interfaces/Dtos/client-type.dto';
import { ClientDto } from 'src/app/interfaces/Dtos/client.dto';
import { ClientService } from './services/client.service';

@Component({
  selector: 'neoris-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css']
})
export class ClientComponent implements OnInit {

  page: number
  sizePagination: number = 8
  clientList: ClientDto[]
  clientListFilter: ClientDto[]
  clientListFilterShow: ClientDto[]
  clientTypesList: ClientTypeDto[]
  clientEdit: ClientDto
  @ViewChild('clientNewEdit') clientNewEdit: ElementRef
  @ViewChild('clientDelete') clientDelete: ElementRef
  condition: string = ''
  deleteClientDto: ClientDto;


  constructor(private render: Renderer2,
    private clientService: ClientService) { }

  ngOnInit() {
    this.LoadData()
  }

  LoadData() {
    forkJoin([
      this.clientService.GetClients(),
      this.clientService.GetClientTypes()
    ]).subscribe(([clients, clientTypes]) => {
      this.clientList = this.setSelected(clients.data, false)
      this.clientListFilter = this.clientList
      this.clientListFilterShow = this.clientListFilter
      this.clientTypesList = clientTypes.data
      this.SetNamesId()
    })
  }

  setSelected(data: ClientDto[], arg1: boolean): ClientDto[] {
    return data.map(client => ({
      ...client,
      selected: arg1
    }))
  }

  SetNamesId() {
    this.clientListFilter.forEach(client => {
      client.clientTypeName = this.clientTypesList.filter(t => t.id === client.clientTypeId)[0].name
      client.parentIdName = this.clientList.filter(t => t.id === client.parentId)[0]?.name
    });
  }

  ShowModal() {
    const clientNewEdit = this.clientNewEdit.nativeElement
    this.render.setStyle(clientNewEdit, 'display', 'block')
  }

  NuevoCliente() {
    this.clientEdit = null
    this.ShowModal()
    this.condition = 'New Client'
  }

  CloseModal() {
    const clientNewEdit = this.clientNewEdit.nativeElement
    this.render.setStyle(clientNewEdit, 'display', 'none')
  }

  CloseModalDelete() {
    const clientDelete = this.clientDelete.nativeElement
    this.render.setStyle(clientDelete, 'display', 'none')
  }

  EditClient(client: ClientDto) {
    this.clientEdit = client
    // console.log(client)
    this.ShowModal()
    this.condition = 'Edit Client'
  }

  DeleteClient(client: ClientDto) {
    const clientDelete = this.clientDelete.nativeElement
    this.render.setStyle(clientDelete, 'display', 'block')
    this.deleteClientDto = client
  }

  async DeleteClientDto() {
    const clientDelete = this.clientDelete.nativeElement
    const response = await this.clientService.DeleteClient(this.deleteClientDto.id).toPromise()
    console.log(response)
    this.render.setStyle(clientDelete, 'display', 'none')
    this.LoadData()
  }

  onSearchChange(searchValue: string): void {
    this.clientListFilterShow = []
    this.clientListFilterShow = this.clientListFilter
      .filter(c => (c.code.toLowerCase().indexOf(searchValue.toLowerCase()) > -1)
        || c.name?.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
        || c.parentIdName?.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
        || c.govNumber?.toString().toLowerCase().indexOf(searchValue.toLowerCase()) > -1
        || c.clientTypeName?.toLowerCase().indexOf(searchValue.toLowerCase()) > -1)
  }

}
